import axios from "axios";

const apiJson = axios.create({
    baseURL: process.env.API_ROUTE || 'https://api-panel-cms.unitek-indonesia.com/api',
    // baseURL: process.env.API_ROUTE || 'http://127.0.0.1:8000/api',
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json',
    }
});

apiJson.interceptors.response.use(
    response => response,
    error => {
        console.error("API error : ", error);
        return Promise.reject(error);
    }
);

export default apiJson;